module.exports = __webpack_public_path__ + "img/login-v2-dark.7765b1e1.svg";